import React from "react";
import {useTranslation} from "react-i18next";
import './Footer.css';
import dmarcFlowLogo from '../assets/img/dmarc-flow-logo.webp'
import appname from "../appname";
import {routes} from "../routes";
import {I18nService} from "../service/i18nService";

const Footer = () => {
    const {t} = useTranslation();
    const i18nService = new I18nService();
    const language = i18nService.getLanguage();
    const now = new Date();

    const link = (lang, routeName) => `${appname}/${lang}/${routes[routeName][lang]}`;

    return (
        <footer className="pt-5 pb-3">
            <div className="container pt-5 pb-5">
                <div className="row gy-4 pt-5 pb-5">

                    <div className="col-md-4">
                        <img src={dmarcFlowLogo} alt="Logo DMARCFlow" height="40"
                             className="mb-3"/>
                        <p className="fs-6 pe-md-4">
                            {t("pages.footer.appDescription")}
                        </p>
                    </div>

                    <div className="col-md-4">
                        <h5 className="mb-3"><i className="bi bi-list me-2"></i>{t("pages.footer.navigation.title")}
                        </h5>
                        <ul className="list-unstyled small">
                            <li><i className="bi bi-house me-2"></i><a href={link(language, "home")}
                                                                       className=" text-decoration-none">{t("pages.footer.navigation.entries.home")}</a>
                            </li>
                            <li><i className="bi bi-shield-lock me-2"></i><a href={link(language, "dmarcRecordChecker")}
                                                                             className=" text-decoration-none">{t("pages.footer.navigation.entries.dmarc")}</a>
                            </li>
                            <li><i className="bi bi-shield-check me-2"></i><a
                                href={link(language, "spfRecordChecker")}
                                className=" text-decoration-none">{t("pages.footer.navigation.entries.spf")}</a>
                            </li>
                            <li><i className="bi bi-patch-check me-2"></i><a href={link(language, 'dkimRecordChecker')}
                                                                             className=" text-decoration-none">{t("pages.footer.navigation.entries.dkim")}</a>
                            </li>
                            <li><i className="bi bi-tag me-2"></i><a href={link(language, 'bimiRecordChecker')}
                                                                     className=" text-decoration-none">{t("pages.footer.navigation.entries.bimi")}</a>
                            </li>
                            <li><i className="bi bi-sliders2-vertical me-2"></i><a
                                href={link(language, 'pricing')}
                                className=" text-decoration-none">{t("pages.footer.navigation.entries.pricing")}</a>
                            </li>
                        </ul>
                    </div>

                    <div className="col-md-4">
                        <h5 className="mb-3"><i className="bi bi-telephone me-2"></i>{t("pages.footer.contact.title")}
                        </h5>
                        <span className={"small"}>{t("pages.footer.company")}</span>
                        <ul className="list-unstyled small">
                            <li><i className="bi bi-envelope me-2"></i>{t("pages.footer.contact.email")}: <a href="#"
                                                                                                             className="">info
                                [at] ucar-solutions.de</a></li>
                            <li><i className="bi bi-phone me-2"></i>{t("pages.footer.contact.phone")}: <a
                                href="tel:+49123456789"
                                className="">+49 6192 98 99
                                814</a></li>
                            <li><i className="bi bi-geo-alt me-2"></i>{t("pages.footer.contact.address")}: Feldstraße 1,
                                65719 Hofheim am Taunus
                            </li>
                        </ul>
                    </div>
                </div>

                <hr className="border-secondary mt-4"/>
                <div className="d-flex justify-content-between flex-wrap small pt-2">
                    <div>&copy; 2021 - {now.getFullYear()} <a href={"https://ucar-solutions.de"}
                                                              className={"text-decoration-none"}
                                                              target={"_blank"}> {t("pages.footer.company")}</a></div>
                    <div>
                        <a href={"https://ucar-solutions.de/impressum"} target={"_blank"}
                           className=" me-3 text-decoration-none">{t("pages.footer.imprint")}</a>
                        <a href={link(language, 'privacyPolicy')}
                           className=" text-decoration-none">{t("pages.footer.privacy")}</a>
                    </div>
                </div>
            </div>
        </footer>

    );
};

export default Footer;
